export default "/_next/static/images/Farmhouse-1668328c855b0fde5a578686cb724115.png";